import { render, staticRenderFns } from "./FechamentoGeral.vue?vue&type=template&id=db3e944c&scoped=true&"
import script from "./FechamentoGeral.vue?vue&type=script&lang=js&"
export * from "./FechamentoGeral.vue?vue&type=script&lang=js&"
import style0 from "./FechamentoGeral.vue?vue&type=style&index=0&id=db3e944c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3e944c",
  null
  
)

export default component.exports